export const links = [
  {
    id: 1,
    url: "https://forms.gle/111RjQwyZ56pNZQi9",
    text: "Registration",
  },
  {
    id: 2,
    url: "https://ocasys.rug.nl/2026-2027/catalog/course/WBCS045-05",
    text: "Ocasys",
  },
  {
    id: 3,
    url: "#contact",
    text: "Contact",
  },
];
